import { inject } from 'mobx-react';
import { LangDrawerComponent } from './component';
export const LangDrawer = inject(({ ui }) => ({
    setLanguage: ui.setLanguage,
    language: ui.language,
}))(LangDrawerComponent);
//# sourceMappingURL=index.js.map